import { AXIOS_ERP } from "../Config/api.config";

export const createERPApiEndpoint = (
  endpoint,
  params = { page: 1, take: 20, q: "" },
  custom_url = ""
) => {
  let url = endpoint + custom_url + "/";

  const headers = {
    Authorization: "Bearer " + localStorage.getItem("erp-token") || "",
  };

  let options = { headers, params };

  return {
    fetchAll: () => AXIOS_ERP.get(url, options),
    customGet: () => AXIOS_ERP.get(url, options),
    customPost: (newRecord) => AXIOS_ERP.get(url, newRecord, options),
    fetchById: (id) => AXIOS_ERP.get(url + id, { headers }),
    create: (newRecord) => AXIOS_ERP.post(url, newRecord, { headers }),
    create2: (newRecord) => AXIOS_ERP.post(url, newRecord, options),
    update: (id, updatedRecord) =>
      AXIOS_ERP.put(url + id, updatedRecord, { headers }),
    update2: (updatedRecord) => AXIOS_ERP.put(url, updatedRecord, { headers }),
    delete: (id) => AXIOS_ERP.delete(url + id, { headers }),
  };
};
